'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAudit$002dView$0024$002dAudit$002dName from "./presto.-Audit-View$-Audit-Name.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$AuditName$() {
}
export { $c_Lpresto_AuditView$AuditName$ as $c_Lpresto_AuditView$AuditName$ };
$p = $c_Lpresto_AuditView$AuditName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$AuditName$;
/** @constructor */
function $h_Lpresto_AuditView$AuditName$() {
}
export { $h_Lpresto_AuditView$AuditName$ as $h_Lpresto_AuditView$AuditName$ };
$h_Lpresto_AuditView$AuditName$.prototype = $p;
$p.l = (function() {
  return "AuditName";
});
$p.cGW = (function(x$0) {
  return new $j_presto$002e$002dAudit$002dView$0024$002dAudit$002dName.$c_Lpresto_AuditView$AuditName(x$0.j(0), (!(!x$0.j(1))));
});
var $d_Lpresto_AuditView$AuditName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$AuditName$, "presto.AuditView$AuditName$", ({
  EN: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_AuditView$AuditName$ as $d_Lpresto_AuditView$AuditName$ };
var $n_Lpresto_AuditView$AuditName$;
function $m_Lpresto_AuditView$AuditName$() {
  if ((!$n_Lpresto_AuditView$AuditName$)) {
    $n_Lpresto_AuditView$AuditName$ = new $c_Lpresto_AuditView$AuditName$();
  }
  return $n_Lpresto_AuditView$AuditName$;
}
export { $m_Lpresto_AuditView$AuditName$ as $m_Lpresto_AuditView$AuditName$ };
//# sourceMappingURL=presto.-Audit-View$-Audit-Name$.js.map
